<template>
    <div class="withdraw">
        <div class="bread-crumbs">
            <div class="crumbs-item" @click="onBackAC">资产中心</div>
            <Icon type="ios-arrow-forward" class="crumbs-icon" size="14" />
            <div class="crumbs-item" @click="onShowLog">{{ type == 1 ? '支付账户明细' : '店铺账户明细' }}</div>
            <Icon type="ios-arrow-forward" class="crumbs-icon" size="14" />
            <div class="crumbs-item active">提现记录</div>
        </div>
        <div class="title-box">
            <div class="title">提现记录</div>
            <Dropdown class="search-time-box" @on-click="onTimeFilter" v-show="false">
                <div class="time-dropdown">
                    <div class="time-value">{{ current_time_filter }}</div>
                    <Icon type="ios-arrow-down" class="arrow-down-icon" />
                </div>
                <DropdownMenu slot="list">
                    <DropdownItem v-for="(item,index) in time_filter" :key="index" :name="item.value">{{item.name}}</DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </div>
        <table>
            <thead>
                <tr>
                    <th>发起时间</th>
                    <th>提现单号</th>
                    <th>提现金额</th>
                    <th>状态</th>
                    <th>银行卡号</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item,index) in list" :key="index"> 
                    <td class="time">{{item.create_time}}</td>
                    <td class="order-id">{{item.trade_no}}</td>
                    <td class="amount">¥{{item.money | price_format}}</td>
                    <td>
                        <div class="status">
                            <p>{{item.status | status_filter}}</p>
                            <p v-if="item.status == 0" class="table-tips">预计3个工作日内到账</p>
                        </div>
                    </td>
                    <td>
                        <div class="bank-card">
                            <p>{{ item.card_no }}</p>
                            <p class="table-tips">({{ item.card_bank }})</p>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="pagination-container">
            <Page :total="total_count" prev-text="上一页" next-text="下一页" @on-change="onPageChange"></Page>
        </div>
    </div>
</template>
<script>
import { shopWithdrawLog } from '@/api/index';
export default{
    name:"WithdrawLog",
    props:{
        type:{
            type:[String,Number],
            default:2
        }
    },
    filters:{
        status_filter(val){
            switch(Number(val)){
                case 1:
                    return '提现成功';
                default:
                    return '提现处理中';
            }
        }
    },
    data(){
        return{
            time_filter:[
                {name:'全部时间',value:''},
                {name:'1个月',value:'1'},
                {name:'3个月',value:'3'},
                {name:'6个月',value:'6'},
                {name:'1年',value:'12'},
                {name:'1年以上',value:'12+'}
            ],
            filter_form:{
                type:'-1',
                keyword:"",
                page:1,
                limit:10,
                time_range:''
            },
            list:[],
            total:0
        }
    },
    computed:{
        current_time_filter(){
            const {filter_form,time_filter} = this;
            return time_filter.filter((item)=>item.value === filter_form.time_range)[0].name;
        },
    },
    mounted(){
        this.onGetLog();
    },
    methods:{
        onPageChange(e){
            console.log('page_change',e);
            this.filter_form.page = e;
            this.onGetLog();
        },
        async onGetLog(){
            try{
                const {code,msg,data} = await shopWithdrawLog(this.filter_form);
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                console.log('data-withdraw-log',data);
                this.list = data.list;
                this.total = data.count;
            }catch(e){
                console.log('err-withdraw-log',e);
                this.$layer.msg(e.msg);
            }
        },
        onTimeFilter(time){
            console.log('time',time);
            this.filter_form.page = 1;
            this.filter_form.time_range = time;
            this.onGetLog();
        },
        onShowLog(){
            this.$emit('show-log',{type:this.type});
        },
        onBackAC(){
            this.$emit('show-asset-center');
        }
    }
}
</script>
<style lang="scss" scoped>
.withdraw{
    width:100%;
    background:#fff;
    padding:30px;
    .bread-crumbs{
        display:flex;
        align-items:center;
        column-gap:8px;
        padding-bottom:22px;
        border-bottom:1px solid #d6d6d6;
        .crumbs-item{
            color:#999;
            font-size:14px;
            cursor:pointer;
            &:hover, &.active{
                color:#333;
            }
        }
    }
    .title-box{
        width:100%;
        display:flex;
        align-items:center;
        justify-content:space-between;
        margin-top:36px;
        .title{
            color:#333;
            font-size:18px;
            font-weight:bold;
        }
        .search-time-box{
            background:#f9fafb;
            border:1px solid #ebebeb;
            border-radius:8px;
            width:114px;
            height:38px;
            cursor:pointer;
            .time-dropdown{
                width:100%;
                height:38px;
                display:flex;
                align-items:center;
                justify-content:center;
                column-gap:8px;
                .time-value{
                    color:#333333;
                    font-size:14px;
                }
                .arrow-down-icon{
                    width:16px;
                    height:16px;
                }
            }
        }
    }
    table{
        width:100%;
        margin-top:24px;
        table-layout:fixed;
        border-collapse: collapse;
        th,td{
            text-align:center;
        }
        thead{
            background:#edeff2;
            tr{
                height:48px;
            }
        }
        tbody{
            tr{
                height:56px;
                &:hover{
                    background:#edeff2;
                }
                td{
                    border-bottom:1px solid #e3e3e3;
                    font-size:14px;
                    color:#333;
                    &.bank-card{
                        height:100%;
                        display:flex;
                        flex-direction:column;
                        align-items:center;
                    }
                }
            }
        }
    }
    .pagination-container{
        margin-top:20px;
        display:flex;
        justify-content:flex-end;
        align-items:center;
    }
}
.table-tips{
    color:#999;
    font-size:12px;
}
</style>